import {
  pageConstants,
  alertConstants,
  userConstants,
  pagetypeConstants,
} from "../constants";
import { alertActions } from "./alert.actions.js";
import { pageService } from "../services";

export const pageActions = {
  getPageDetail,
  editPage,
  setCurrentPage,
};

function getPageDetail(page_id) {
  return (dispatch) => {
    dispatch(fetchAlert("fetching page..."));
    dispatch(detailRequest(page_id));

    pageService.getPageDetail(page_id).then(
      (page) => {
        dispatch(refreshToken(page.newToken));
        dispatch(clearAlert());
        dispatch(success(page));
      },
      (error) => {
        dispatch(clearAlert());
        dispatch(failure(error));
        /*dispatch(alertActions.error('unable to reach remote server.'));*/
      }
    );
  };

  function fetchAlert(message) {
    return { type: alertConstants.SPINNER, message };
  }
  function detailRequest(page_id) {
    return { type: pageConstants.PAGE_DETAIL_REQUEST, page_id };
  }
  function refreshToken(token) {
    return { type: userConstants.TOKEN_REFRESH, token };
  }
  function clearAlert() {
    return { type: alertConstants.CLEAR };
  }
  function success(page) {
    return { type: pageConstants.PAGE_DETAIL_SUCCESS, page };
  }
  function failure(message) {
    return { type: pageConstants.PAGE_DETAIL_FAILURE, message };
  }
}

function editPage(page_info) {
  return (dispatch) => {
    dispatch(spinner("changing page type..."));
    dispatch(editRequest(page_info));

    pageService.editPage(page_info).then(
      (response) => {
        dispatch(refreshToken(response.newToken));
        dispatch(clearAlert());
        dispatch(success(page_info));
        dispatch(refreshPagetypes());
      },
      (error) => {
        dispatch(clearAlert());
        dispatch(failure(page_info));
        dispatch(
          alertActions.error("There was a problem changing the page type.")
        );
      }
    );
  };

  function spinner(message) {
    return { type: alertConstants.SPINNER, message };
  }
  function editRequest(page_info) {
    return { type: pageConstants.PAGE_EDIT_REQUEST, page_info };
  }
  function refreshToken(token) {
    return { type: userConstants.TOKEN_REFRESH, token };
  }
  function clearAlert() {
    return { type: alertConstants.CLEAR };
  }
  function success(page_info) {
    return { type: pageConstants.PAGE_EDIT_SUCCESS, page_info };
  }
  function failure(page_info) {
    return { type: pageConstants.PAGE_EDIT_FAILURE, page_info };
  }
  function refreshPagetypes() {
    return { type: pagetypeConstants.PAGETYPE_LIST_REQUEST };
  }
}

function setCurrentPage(page) {
  return (dispatch) => {
    dispatch(setCurrentPage(page));
  };

  function setCurrentPage(page) {
    return { type: pageConstants.PAGE_SET_CURRENT_PAGE, page };
  }
}
